import TablePageList from './tablePageList.vue';

export default TablePageList;
